module.exports = __webpack_public_path__ + "img/logo_everymobile.408443d1.svg";